



























































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import {namespace} from "vuex-class";
import {IApiErrors} from '@/models/ApiModels';
import {ILogin} from '@/models/loginModels';
import {errorHandler} from "@/services/services";
import {LOGIN_ROUTES, OTHER_ROUTES} from "@/constants/routes";
import {ANALYTIC_CLICKS} from "@/services/Analytics";
import {stripHtmlTags} from "@/helpers/stringHelpers";


const userDataModule = namespace("userData");

@Component({
  name: 'LoginForm',
  components: {},
})
export default class LoginForm extends Vue {
  @userDataModule.Action('loginUser')
  private loginUser !: (userData: ILogin) => Promise<any>;

  private loading: boolean = false;

  private email: string = "";
  private password: string = "";

  private errors: IApiErrors = {};

  @Prop({default: true})
  private emitNextAtLogin !: boolean;

  private sanitizeInputs() {
    this.email = stripHtmlTags(this.email);
  }

  get activeButton(): boolean {
    return (this.email.length > 2) && this.password !== '';
  }

  private returnToHomeUrlIfNecessary() {
    // we need those urls to clean because if the user saves them, they will always reset their credentials
    if (this.$route.name === LOGIN_ROUTES.LOGIN || this.$route.name === LOGIN_ROUTES.REGISTER) {
      this.$router.push({name: OTHER_ROUTES.HOME});
    }
  }


  private sendLoginForm() {
    // here we start the login
    if (this.activeButton) {
      this.sanitizeInputs();
      ANALYTIC_CLICKS.loginButton(this.$gtag);
      this.clearErrors();
      this.loading = true;

      const loginBody: ILogin = {
        email: this.email,
        password: this.password,
      };

      this.loginUser(loginBody)
          .then(() => this.emitNextAtLogin ? this.$uiBus.emit("intro:next") : null)
          .then(() => this.returnToHomeUrlIfNecessary())
          .catch(this.showErrors)
          .finally(() => this.loading = false);
    }

  }

  private showErrors(err: any) {
    const errors = errorHandler.handleErrorsResponse(err, 'loginForm.errors');
    Vue.set(this, 'errors', errors);
  }

  private clearErrors() {
    Vue.set(this, 'errors', {});
  }

  private removeError(e: any) {
    Vue.set(this.errors, e, '');
  }

}
